import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiVariantGenerationAssistantCacheKeys: AllRouteEndpoints[] = [];
